import { render, staticRenderFns } from "./SalesDashboardTotalChart.vue?vue&type=template&id=780e66d2&"
import script from "./SalesDashboardTotalChart.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardTotalChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports